import l10n from "diy/util/l10n";
import {notificationCenterObserver} from "diy/externalwebsiteimport/NotifierObservers/NotificationCenterObserver";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.EXTERNAL_WEBSITE_IMPORT_SKIPPED,
    testId: "external-website-import-skipped",
    trackingId: "ExternalWebsiteImportSkippedNotification",

    content: l10n("migration.notification.later.text"),

    mainAction: {
        testId: "start-import",
        label: l10n("migration.notification.later.button"),
        onClick: () => {
            if (typeof notificationCenterObserver.actionHandler === "function") {
                notificationCenterObserver.actionHandler();
            }
        }
    },

    bubbleOptions: {
        closable: false
    },

    cardOptions: {
        closable: false
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/ExternalWebsiteImportSkipped.ts
 **/